import {
  createTimelineForTicketsLeg,
  createTimelineForCheckoutHop,
} from '../timeline'

export const createScheduledTimelineForTicketsItinerary = (response, itineraryIndex, isOutbound) => {
  const itinerary = isOutbound
    ? response.outboundItineraries[itineraryIndex]
    : response.inboundItineraries && response.inboundItineraries[itineraryIndex]

  // Loop through the Legs and Legs' Hops
  const result = []
  itinerary.legs.forEach((legIndex) => {
    result.push(...createTimelineForTicketsLeg(response, isOutbound, itineraryIndex, legIndex))
  })

  return result
}

export const createScheduledTimelineForCheckoutItinerary = (hops, operators) => {
  const result = []
  hops.forEach((hop, index) => {
    const operator  = operators[hop.operator]
    result.push(...createTimelineForCheckoutHop(hops, index, operator))
  })

  return result
}
